export default __webpack_public_path__ + "static/media/arrows-chevron-down.604b532d.svg";